// Mock data for Second Missionary Baptist Church App

export const mockUser = {
  id: "user-1",
  firstName: "John",
  lastName: "Smith",
  email: "john.smith@email.com",
  phone: "559-555-1234",
  role: "member", // member, pastor, admin
  avatar: null,
  memberSince: "2020-01-15",
  bio: "Proud member of SMBC family"
};

export const mockDevotional = {
  id: "dev-1",
  date: new Date().toISOString().split('T')[0],
  verse: "Trust in the LORD with all thine heart; and lean not unto thine own understanding. In all thy ways acknowledge him, and he shall direct thy paths.",
  reference: "Proverbs 3:5-6",
  reflection: "Today, let us remember that God's wisdom far exceeds our own. When we surrender our plans to Him, He guides our steps with perfect love and purpose."
};

export const mockAnnouncements = [
  {
    id: "ann-1",
    title: "Sunday Service Schedule Update",
    content: "Join us this Sunday at 10:00 AM for morning worship. Bible Study continues Wednesday at 7:00 PM.",
    createdAt: "2025-07-10T09:00:00Z",
    author: "Pastor Williams",
    priority: "high"
  },
  {
    id: "ann-2",
    title: "Youth Summer Camp Registration",
    content: "Registration is now open for our annual youth summer camp. Contact the church office for details.",
    createdAt: "2025-07-08T14:00:00Z",
    author: "Youth Ministry",
    priority: "normal"
  },
  {
    id: "ann-3",
    title: "Food Drive This Month",
    content: "Please bring non-perishable food items to support our community food bank ministry.",
    createdAt: "2025-07-05T10:00:00Z",
    author: "Outreach Committee",
    priority: "normal"
  }
];

export const mockPrayers = [
  {
    id: "prayer-1",
    userId: "user-2",
    userName: "Sarah Johnson",
    request: "Please pray for my mother's surgery next week. She needs strength and healing.",
    createdAt: "2025-07-10T08:30:00Z",
    prayerCount: 15,
    comments: [
      {
        id: "comment-1",
        userId: "user-3",
        userName: "Mary Davis",
        text: "Praying for your mother, Sarah. God is faithful!",
        createdAt: "2025-07-10T09:00:00Z"
      }
    ]
  },
  {
    id: "prayer-2",
    userId: "user-4",
    userName: "Robert Williams",
    request: "Seeking prayers for our family as we navigate a difficult season. Thank you, church family.",
    createdAt: "2025-07-09T15:00:00Z",
    prayerCount: 23,
    comments: []
  },
  {
    id: "prayer-3",
    userId: "user-5",
    userName: "Lisa Thompson",
    request: "Praise report! My son got the job he's been praying for. Thank you all for your prayers!",
    createdAt: "2025-07-08T12:00:00Z",
    prayerCount: 31,
    comments: [
      {
        id: "comment-2",
        userId: "user-1",
        userName: "John Smith",
        text: "Glory to God! So happy for your family!",
        createdAt: "2025-07-08T13:00:00Z"
      }
    ]
  }
];

export const mockDirectory = [
  {
    id: "user-1",
    firstName: "John",
    lastName: "Smith",
    email: "john.smith@email.com",
    phone: "559-555-1234",
    role: "member",
    avatar: null
  },
  {
    id: "user-2",
    firstName: "Sarah",
    lastName: "Johnson",
    email: "sarah.j@email.com",
    phone: "559-555-2345",
    role: "member",
    avatar: null
  },
  {
    id: "user-3",
    firstName: "Mary",
    lastName: "Davis",
    email: "mary.d@email.com",
    phone: "559-555-3456",
    role: "deacon",
    avatar: null
  },
  {
    id: "user-pastor",
    firstName: "Pastor David",
    lastName: "Williams",
    email: "pastor@smbcmadera.org",
    phone: "559-555-0001",
    role: "pastor",
    avatar: null
  },
  {
    id: "user-4",
    firstName: "Robert",
    lastName: "Williams",
    email: "robert.w@email.com",
    phone: "559-555-4567",
    role: "member",
    avatar: null
  },
  {
    id: "user-5",
    firstName: "Lisa",
    lastName: "Thompson",
    email: "lisa.t@email.com",
    phone: "559-555-5678",
    role: "member",
    avatar: null
  }
];

export const mockMessages = [
  {
    id: "msg-1",
    senderId: "user-2",
    senderName: "Sarah Johnson",
    recipientId: "user-1",
    subject: "Welcome to the choir!",
    content: "Hi John, we're so excited to have you join the choir! Practice is every Thursday at 6 PM.",
    createdAt: "2025-07-10T10:00:00Z",
    read: false
  },
  {
    id: "msg-2",
    senderId: "user-pastor",
    senderName: "Pastor David Williams",
    recipientId: "user-1",
    subject: "Thank you for volunteering",
    content: "John, thank you for signing up to help with the food drive. Your servant's heart is a blessing to our church.",
    createdAt: "2025-07-09T14:00:00Z",
    read: true
  },
  {
    id: "msg-3",
    senderId: "user-3",
    senderName: "Mary Davis",
    recipientId: "user-1",
    subject: "Bible Study Materials",
    content: "Here are the study materials for next week's session. Looking forward to seeing you there!",
    createdAt: "2025-07-07T09:00:00Z",
    read: true
  }
];

export const churchInfo = {
  name: "Second Missionary Baptist Church",
  address: "828 South A Street, Madera, CA 93638",
  phone: "(559) 673-3977",
  email: "info@smbcmadera.org",
  logo: "https://smbcmadera.org/_assets/media/ea7782669b4b02a679d9f22109e4bd99.png",
  youtubeUrl: "https://www.youtube.com/@SecondMissionaryBaptistMadera",
  facebookUrl: "https://www.facebook.com/profile.php?id=100064658171372",
  mapUrl: "https://www.google.com/maps/search/?api=1&query=828+South+A+Street+Madera+CA+93638",
  services: [
    { day: "Sunday", time: "10:45 AM", name: "Morning Worship" },
    { day: "Wednesday", time: "6:00 PM", name: "Bible Study" }
  ]
};

export const prayerWallScripture = {
  verse: "Pray without ceasing.",
  reference: "1 Thessalonians 5:17",
  version: "KJV"
};
